/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Packaging_Material_Deduct_On_DeliveryInputs */

const vi_packaging_material_deduct_on_delivery = /** @type {(inputs: Packaging_Material_Deduct_On_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khi giao đơn hàng`)
};

/**

* @param {Packaging_Material_Deduct_On_DeliveryInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const packaging_material_deduct_on_delivery = /** @type {((inputs?: Packaging_Material_Deduct_On_DeliveryInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Packaging_Material_Deduct_On_DeliveryInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_packaging_material_deduct_on_delivery(inputs)
});